module.exports = __webpack_public_path__ + "img/weixin.3f890fc7.png";